import {
  collection,
  query,
  where,
  getDocs,
  onSnapshot,
  serverTimestamp,
  addDoc,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from './firebase';

const COLLECTION = 'announcements';

/**
 * Send a broadcast announcement (creates Firestore doc + optional email)
 * Calls the `sendBroadcast` Cloud Function.
 */
export const sendBroadcast = async ({ title, message, organizationId, sendEmail }) => {
  const fn = httpsCallable(functions, 'sendBroadcast');
  const result = await fn({ title, message, organizationId, sendEmail });
  return result.data;
};

/**
 * Get announcements for an organization (most recent first)
 */
export const getAnnouncementsByOrg = async (organizationId, limitCount = 30) => {
  const q = query(collection(db, COLLECTION), where('organizationId', '==', organizationId));
  const snapshot = await getDocs(q);
  const announcements = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  announcements.sort((a, b) => (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0));
  return announcements.slice(0, limitCount);
};

/**
 * Subscribe to org announcements in real time
 */
export const subscribeToAnnouncements = (organizationId, callback, limitCount = 10) => {
  const q = query(collection(db, COLLECTION), where('organizationId', '==', organizationId));
  return onSnapshot(q, (snapshot) => {
    const announcements = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
    announcements.sort((a, b) => (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0));
    callback(announcements.slice(0, limitCount));
  });
};
